var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_155_3759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 11L10 10M5.75 10.5C6.37378 10.5 6.99145 10.3771 7.56775 10.1384C8.14404 9.89972 8.66768 9.54984 9.10876 9.10876C9.54984 8.66768 9.89972 8.14404 10.1384 7.56775C10.3771 6.99145 10.5 6.37378 10.5 5.75C10.5 5.12622 10.3771 4.50855 10.1384 3.93225C9.89972 3.35596 9.54984 2.83232 9.10876 2.39124C8.66768 1.95016 8.14404 1.60028 7.56775 1.36157C6.99145 1.12286 6.37378 1 5.75 1C4.49022 1 3.28204 1.50045 2.39124 2.39124C1.50044 3.28204 1 4.49022 1 5.75C1 7.00978 1.50044 8.21796 2.39124 9.10876C3.28204 9.99956 4.49022 10.5 5.75 10.5V10.5Z",
    stroke: "#292D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_3759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9183fcc4bac6b42207cef19212c4ac1d.svg";
export { ForwardRef as ReactComponent };